<template>
  <div class="Top">
    <div id="notificationWrap" class="contentsWidth mx-auto mt-4">

      <div class="row col-12">
        <p class="title">{{userInfo.sei}}さんへのお知らせ</p>
      </div>
      <perfect-scrollbar id="notificationArea" class="row col-12 m-0">
        <table class="table p-0">
          <tbody>
            <tr v-for="(notification, kei, index) in notification" :key="index">
              <th>
                {{notification.dateFrom}}
              </th>
              <td class="icon">
                <b-badge variant="danger" v-if="notification.elapsed <= 7">新着</b-badge>
              </td>
              <td class="ml-3 newsText">{{notification.notification}}</td>
            </tr>
            <tr v-if="notification !== null && notification.length === 0">
              <td class="none-data text-left">通知はありません。</td>
            </tr>
          </tbody>
        </table>
      </perfect-scrollbar>
    </div>
    <div id="newsWrap" class="contentsWidth mx-auto mt-4">
      <div class="row col-12">
        <p class="title">お知らせ</p>
      </div>
      <perfect-scrollbar id="newsArea" class="row col-12 m-0">
        <table class="table p-0">
          <tbody>
            <tr v-for="(news, kei, index) in news" :key="index">
              <th>{{news.dateFrom}}</th>
              <td class="icon"></td>
              <td class="ml-3 newsText">{{news.news}}</td>
            </tr>
            <tr v-if="news !== null && news.length === 0">
              <td class="ml-3 text-left">お知らせはありません。</td>
            </tr>
          </tbody>
        </table>
      </perfect-scrollbar>
    </div>
    <div id="applicantWrap" class="mt-4 contentsWidth mx-auto">
      <div v-if="isApped" class="title">助成決定プログラム</div>
      <div v-else class="title">助成申請書</div>
      <b-table
        show-empty
        :fields="heads.app"
        :items="showData.app"
        thead-class="tableHead"
        tbody-tr-class="dataWrap"
        table-class="icon-white"
        id="applicantTable"
      >
        <template v-slot:cell(name)="data">
          <b-link
            v-if="data.item.status === '未申請'"
            :to="'/application/'+data.item.typeId">{{data.item.name}}</b-link>
          <b-link
            v-else
            :to="'/application/form/'+data.item.typeId">{{data.item.name}}</b-link>
        </template>
        <template v-slot:cell(appDate)="data">
          <b-link
            v-if="data.item.status === '未申請'"
            :to="'/application/'+data.item.typeId">
            {{data.item.appDate}}</b-link>
          <b-link
            v-else
            :to="'/application/form/'+data.item.typeId">
            {{data.item.appDate}}</b-link>
        </template>
        <template v-slot:cell(copyLink)="data">
          <b-link
            @click="exportPdf(data.item.typeId, 'app', data.item.name)"
            v-if="data.item.hasPrintPreview"
            class="printBtn">
            PDF出力
          </b-link>
          <div class="printBtn nonePrintView" v-else>
            PDF出力
          </div>
        </template>
        <template v-slot:empty="scope">
          <p class="none-data">申請可能な助成プログラムがありません。</p>
        </template>
      </b-table>
    </div>

    <div id="reportWrap" class="contentsWidth mx-auto reqDockWrap" v-if="showData.requiredDoc.length > 0">
      <div class="title">助成手続き書類
        <b-navbar-brand
        class="provisionsLink"
        @click="downloadProvisions">
          <b-link>KDDI財団助成援助規程抜粋</b-link>
        </b-navbar-brand>
      </div>
      <b-table
        :fields="heads.requiredDoc"
        :items="showData.requiredDoc"
        thead-class="tableHead"
        tbody-tr-class="dataWrap"
        table-class="icon-white"
        id="reportTable"
      >
        <template v-slot:cell(name)="data">
          <b-link
            v-if="data.item.can_link_form"
            :to="repLink(data.item)">{{data.item.name}}</b-link>
          <span v-if="!data.item.can_link_form">{{data.item.name}}</span>
        </template>
        <template v-slot:cell(reportDate)="data">
          <b-link
            v-if="data.item.can_link_form"
            :to="repLink(data.item)">
            {{data.item.from}} ~ {{data.item.to}}
          </b-link>
          <span v-if="!data.item.can_link_form">{{data.item.from}} ~ {{data.item.to}}</span>
        </template>
      </b-table>
    </div>

    <div id="changeWrap" class="contentsWidth mx-auto" v-if="showData.change.length > 0">
      <div class="title">計画変更申請
        <span class="changeComment">申請内容に変更が生じた場合に適宜提出</span>
      </div>
      <b-table
        :fields="heads.change"
        :items="showData.change"
        thead-class="tableHead"
        tbody-tr-class="dataWrap"
        table-class="icon-white"
        id="reportTable"
      >
        <template v-slot:cell(name)="data">
          <b-link
            v-if="data.item.can_link_form"
            :to="`/change/form/${data.item.appId}/${data.item.sort}`">{{data.item.name}}</b-link>
          <span v-if="!data.item.can_link_form">{{data.item.name}}</span>
        </template>
        <template v-slot:cell(no)="data">
          {{data.item.sort}}
        </template>
        <template v-slot:cell(reportDate)="data">
          <b-link
            v-if="data.item.can_link_form"
            :to="`/change/form/${data.item.appId}/${data.item.sort}`">
            {{data.item.from}} ~ {{data.item.to}}
          </b-link>
          <span v-if="!data.item.can_link_form">{{data.item.from}} ~ {{data.item.to}}</span>
        </template>
        <template v-slot:empty="scope">
          <p class="none-data">計画変更申請はありません。</p>
        </template>
      </b-table>
    </div>

    <div id="reportWrap" class="contentsWidth mx-auto" v-if="showData.report.length > 0">
      <div class="title">報告書</div>
      <b-table
        :fields="heads.report"
        :items="showData.report"
        thead-class="tableHead"
        tbody-tr-class="dataWrap"
        table-class="icon-white"
        id="reportTable"
      >
       <template v-slot:cell(name)="data">
          <b-link
            v-if="data.item.can_link_form"
            :to="repLink(data.item)">{{data.item.name}}</b-link>
          <span v-if="!data.item.can_link_form">{{data.item.name}}</span>
        </template>
        <template v-slot:cell(type)="data">
          <span v-if="data.item.isInterim">
            第{{data.item.sort}}回進捗状況報告
          </span>
          <span v-else-if="!data.item.isInterim && data.item.isRequiredDoc">
            助成手続き書類
          </span>
          <span v-else>
            成果報告
          </span>
        </template>
        <template v-slot:cell(reportDate)="data">
<!--           提出期間外
 -->          <b-link
            v-if="data.item.can_link_form"
            :to="repLink(data.item)">
            {{data.item.from}} ~ {{data.item.to}}
          </b-link>
          <span v-if="!data.item.can_link_form">{{data.item.from}} ~ {{data.item.to}}</span>
        </template>
        <template v-slot:cell(export)="data">
          <span v-if="!data.item.isInterim && !data.item.isRequiredDoc">
            <b-link
              v-if="data.item.status !== 3"
              class="printBtn nonePrintView">
              PDF出力
            </b-link>
            <b-link
              v-else
              @click="exportPdf(data.item.apptype_id, 'report', data.item.name)"
              class="printBtn">
              PDF出力
            </b-link>
          </span>
        </template>
        <template v-slot:empty="scope">
          <p class="none-data">報告情報はありません。</p>
        </template>
      </b-table>
    </div>
    <div class="mb-3 mx-auto contentsWidth">
      <p class="text-right">お問い合わせ先:<a class="otoiawase-link" href="mailto:grant@kddi-foundation.or.jp">grant@kddi-foundation.or.jp</a></p>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import api from '@/modules/api';
import download from '@/modules/download';

export default {
  name: 'GasTop',
  components: {},
  data() {
    return {
      userInfo: {},
      heads: {
        app: [
          {
            key: 'name',
            label: '助成プログラム',
            sortable: false,
            class: ['name', 'text-decoration-underline'],
          },
          {
            key: 'year',
            label: '年度',
            sortable: false,
            class: 'year',
          },
          {
            key: 'appDate',
            label: '申請期間',
            sortable: false,
            class: ['appDate', 'text-decoration-underline'],
          },
          {
            key: 'apptypeStatus',
            label: '受付状況',
            sortable: false,
            class: 'status',
          },
          {
            key: 'status',
            label: '申請状況',
            sortable: false,
            class: 'status',
          },
          {
            key: 'copyLink',
            label: '申請書',
            sortable: false,
            class: 'copyLink',
          },
        ],
        change: [
          {
            key: 'name',
            label: '助成中のプログラム',
            sortable: false,
            class: ['name', 'text-decoration-underline'],
          },
          {
            key: 'adopted_date',
            label: '承認年月日',
            sortable: false,
            class: 'adopted_date',
          },
          {
            key: 'no',
            label: '提出番号',
            sortable: false,
            class: ['change_no'],
          },
          {
            key: 'reportDate',
            label: '計画変更申請 提出可能期間（助成期間）',
            sortable: false,
            class: ['reportDate', 'text-decoration-underline'],
          },
          {
            key: 'changeform_status',
            label: '受付状況',
            sortable: false,
            class: 'status',
          },
          {
            key: 'status_text',
            label: '提出状況',
            sortable: false,
            class: 'status',
          },
        ],
        requiredDoc: [
          {
            key: 'name',
            label: '助成中のプログラム',
            sortable: false,
            class: ['name', 'text-decoration-underline'],
          },
          {
            key: 'sub_year',
            label: '年度',
            sortable: false,
            class: 'sub_year',
          },
          {
            key: 'reportDate',
            label: '提出期間',
            sortable: false,
            class: ['reportDate', 'text-decoration-underline'],
          },
          {
            key: 'reptype_status',
            label: '受付状況',
            sortable: false,
            class: 'status',
          },
          {
            key: 'status_text',
            label: '報告状況',
            sortable: false,
            class: 'status',
          },
        ],
        report: [
          {
            key: 'name',
            label: '助成中のプログラム',
            sortable: false,
            class: ['name', 'text-decoration-underline'],
          },
          {
            key: 'type',
            label: '報告の種類',
            sortable: false,
            class: ['rep_type'],
          },
          {
            key: 'reportDate',
            label: '報告期間',
            sortable: false,
            // class: ['reportDate', 'text-decoration-underline'],
          },
          {
            key: 'reptype_status',
            label: '受付状況',
            sortable: false,
            class: 'status',
          },
          {
            key: 'status_text',
            label: '報告状況',
            sortable: false,
            class: 'status',
          },
          {
            key: 'export',
            label: '報告書',
            sortable: false,
            class: 'export',
          },
        ],
      },
      initData: {
        app: [],
        change: [],
        requiredDoc: [],
        report: [],
      },
      showData: {
        app: [],
        change: [],
        requiredDoc: [],
        report: [],
      },
      news: [],
      notification: [],
      isLatesNew: false,
      pdfErr: null,
    };
  },
  methods: {
    async downloadProvisions() {
      this.$store.dispatch('page/onWaiting');
      const response = await api.send('/api/requiredDoc/download/provisions', {}, true)
        .catch((err) => {
          console.error(err);
        });
      this.$store.dispatch('page/offWaiting');
      if (!response) {
        await this.alert('ファイルのダウンロードに失敗しました。');
        return;
      }
      download.blob(response.data, 'KDDI財団助成援助規程抜粋.pdf');
    },
    async initFetch(promiseFuncs) {
      const res = await api.all(promiseFuncs)
        .catch((error) => {
          console.log(error);
          return false;
        });
      if (res !== false) {
        res.map((list) => {
          const listData = list.data;
          const dataType = listData.type;

          switch (dataType) {
            case 'app':
            case 'change':
            case 'requiredDoc':
            case 'report':
              this.setMyList(listData, dataType);
              break;
            case 'news':
              this.news = listData.newsList;
              break;
            case 'notification':
              this.notification = listData.notifications;
              this.isLatesNew = listData.isLatesNew;
              this.userInfo = listData.userInfo;
              break;
            default:
              break;
          }
          return true;
        });
      }
    },
    setMyList(listData, listType) {
      this.showData[listType] = listData.list;
    },
    dataReset(initData) {
      return JSON.parse(JSON.stringify(initData));
    },
    async exportPdf(typeId, type, apptypeName) {
      this.$store.dispatch('page/onWaiting');
      this.pdfErr = null;
      const params = {
        typeId,
        type,
      };
      const requireBlob = true;
      const response = await api.send('/api/export/mypdf', params, requireBlob)
        .catch(async (err) => {
          const error = JSON.parse(await err.response.data.text());
          if (error && error.msg) {
            this.pdfErr = error.msg;
          }
          console.log(err);
        });
      this.$store.dispatch('page/offWaiting');
      if (!response) {
        if (this.pdfErr) {
          await this.alert(this.pdfErr);
        } else {
          await this.alert('ファイルのダウンロードに失敗しました。');
        }
        return;
      }
      const ymd = moment().format('YYYYMMDD');
      const typeText = type === 'app' ? '申請' : '報告';
      const fileName = `${ymd}_${apptypeName}_${typeText}.pdf`;
      download.blob(response.data, fileName);
    },
  },
  computed: {
    repLink() {
      return (rep) => {
        // 助成手続き書類提出の場合
        if (!rep.isInterim && rep.isRequiredDoc) {
          return `/requiredDoc/form/${rep.appId}`;
        }
        // 成果報告の場合
        if (!rep.isInterim) {
          return `/report/form/${rep.appId}`;
        }
        return `/interim/form/${rep.appId}/${rep.sort}`;
      };
    },
    isApped() {
      if (!this.showData.app) {
        return false;
      }
      const saitakData = this.showData.app.find((data) => {
        return data.status === '採択';
      });
      return saitakData;
    },
  },
  // ロード画面
  async created() {
    this.$store.dispatch('page/onLoading');
    const promiseFuncs = [
      api.send('/api/appType/mylist'),
      api.send('/api/changePlan/mylist'),
      api.send('/api/reportType/mylist'),
      api.send('/api/newsList'),
      api.send('/api/notification/mylist'),
      api.send('/api/requiredDoc/mylist'),
    ];
    await this.initFetch(promiseFuncs);
    this.$store.dispatch('page/offLoading');

    // parfectscrollの発火
    setTimeout(() => {
      document.querySelector('#notificationArea').scrollTop = 1;
      document.querySelector('#newsArea').scrollTop = 1;
    }, 0);
  },
};
</script>

<style scoped>
  a.otoiawase-link{
    color: #0E0D69 !important;
  }
  .changeComment{
    margin-left: 1rem;
    color: #0E0D69 !important;
  }
  .provisionsLink{
    margin-left: 1rem;
  }
  .provisionsLink a{
    color: #0E0D69 !important;
    text-decoration: underline;
  }
  .Top{
    padding: 0 5vh;
  }
  .title {
    margin-bottom: 0.5rem;
    color: #333;
  }
  #newsArea,
  #notificationArea {
    height: 20vh;
    overflow-y: scroll;
    background-color: rgba(29, 39, 48, 0.1);
    padding: 15px;
    font-size: 16px;
  }
  #newsArea tr,
  #notificationArea tr{
    padding: 0.1em;
    text-align: left;
  }
  #newsArea td,
  #notificationArea td{
    word-break: break-all;
    white-space: pre-wrap;
  }
  #applicantTable tbody tr:nth-of-type(odd),
  #reportTable tbody tr:nth-of-type(odd) {
      background-color: rgba(0, 0, 0, 0.05);
  }
  #applicantWrap table,
  #reportWrap table, #changeWrap table {
    font-size: 16px;
  }
  #applicantTable td,
  #applicantTable th,
  #reportTable td,
  #reportTable th {
    font-size: 14px;
  }
  #applicantTable .th0,
  #reportTable .th0 {
    width: 25%;
  }
  #year{
    text-align: left;
  }
  #newsArea tr:first-of-type th,
  #newsArea tr:first-of-type td,
  #notificationArea tr:first-of-type th,
  #notificationArea tr:first-of-type td{
    border:none;
  }
  #newsArea th,
  #notificationArea th{
    width: 130px;
  }
  #notificationArea th{
    padding-right: 0;
  }
  .none-data{
    margin:0;
    text-align: center;
  }
  #reportWrap, #changeWrap {
    margin-top: 40px !important;
    margin-bottom: 40px !important;
  }
  td.icon{
    width: 35px;
    padding-left: 0;
    padding-right: 0;
  }
  .printIcon{
    width: 16px;
    height: 16px;
    margin-bottom: 3px;
  }
  .red-text2{
    color: red;
    text-align: center;
    background-color: #ffe460
  }
</style>
<style>
  .changeComment{
    display: inline-block;
    padding-top: 0.3125rem;
    padding-bottom: 0.3125rem;
    margin-right: 1rem;
    font-size: 1.25rem !important;
    line-height: inherit;
    white-space: nowrap;
  }
  #applicantWrap .title,
  #reportWrap .title,
  #changeWrap .title {
    color: #333;
  }
  #applicantWrap .max-w80,
  #reportWrap .max-w80,
  #changeWrap .max-w80 {
    max-width: 80px;
  }
  #applicantWrap .max-w120,
  #reportWrap .max-w120,
  #changeWrap .max-w120 {
    max-width: 120px;
    font-size: 18px;
  }
  #applicantWrap .max-w80,
  #reportWrap .max-w80,
  #changeWrap .max-w80,
  #applicantWrap .container-fluid,
  #reportWrap .container-fluid,
  #changeWrap .container-fluid {
    margin: 0;
    padding: 0;
  }
  .dataWrap{
    border-bottom: solid 1px #CCCCCC;
  }
  #applicantWrap .tableHead,
  #reportWrap .tableHead,
  #changeWrap .tableHead {
    background: #120f69 !important;
    color: #FFF;
    border:solid 2px #FFFFFF;
    height: 40px !important;
    word-break: keep-all;
  }
  #applicantWrap .tableHead th,
  #reportWrap .tableHead th,
  #changeWrap .tableHead th {
    border:solid 1px #CCCCCC;
  }
  td.name{
    word-break: break-all;
  }
  td.status{
    width: 120px;
  }
  td.copyLink{
    width: 120px;
  }
  td.appDate, td.reportDate{
    width: 330px;
    font-weight: bold;
  }
  td.change_no {
    width: 80px;
  }
  td.year{
    width: 60px;
  }
  td.reptype {
    width: 120px;
  }
  #applicantWrap tbody td,
  #reportWrap tbody td,
  #changeWrap tbody td
  {
    vertical-align: middle;
  }
  .printBtn {
    border: solid 1px;
    padding: 5px;
    border-radius: 6px;
    width: 100px;
    display: block;
    font-size: 14px;
    text-align: center;
  }
  .printBtn:hover {
    text-decoration: none;
  }
  .nonePrintView{
    color: #293CB0;
    opacity: 0.3;
  }
  #changeWrap thead th {
    vertical-align:middle !important;
  }
  #notificationArea .table td,
  #notificationArea .table th,
  #newsArea .table td,
  #newsArea .table th {
    vertical-align: top !important;
  }
</style>
